export const HELP_TEXT =
  'This quote is based on the excess selected. Select a higher excess to reduce your premium further (subject to minimum premiums).';

export const LINK_TEXT = 'How excess works';
